export const handleImageUpscale = () => {};

const ASSET_DOMAIN = 'https://assets.pfy.ch';

const loadImage = (image: HTMLImageElement, size: 'md' | 'lg') => {
  image.src = image.src.replace(/(sm|md)/, size);
};

const handleIntersection = (entries: IntersectionObserverEntry[]) => {
  entries.forEach((entry) => {
    if (entry.intersectionRatio > 0) {
      loadImage(entry.target as HTMLImageElement, 'md');
    }
  });
};

const observer = new IntersectionObserver(handleIntersection, {
  root: null,
  rootMargin: '0px',
  threshold: 0.05,
});

document.addEventListener('DOMContentLoaded', () => {
  const allImages = document.getElementsByTagName('img');
  const imagesFromAssets = [...allImages].filter((img) =>
    img.src.includes(ASSET_DOMAIN),
  );

  for (const image of imagesFromAssets) {
    // Exclude images that are already large
    if (image.src.includes('/lg/')) {
      continue;
    }

    observer.observe(image);

    image.setAttribute('originalSrc', image.src);
    image.onerror = () => {
      console.warn('Could not get requested version of image!');
      image.src = image.getAttribute('originalSrc') || '';
      image.onerror = () => {};
    };

    image.addEventListener('click', () => loadImage(image, 'lg'));
  }
});
